"use client";

const HOURS = [
  { day: "Lundi — Vendredi", hours: "08h — 22h" },
  { day: "Samedi", hours: "08h — 23h" },
  { day: "Dimanche & fêtes", hours: "09h — 21h" },
];

const ACCESS = [
  {
    icon: "🚗",
    title: "Voiture",
    lines: ["15 min depuis l'Opéra", "380 places · Gratuit"],
  },
  {
    icon: "🚌",
    title: "Bus RATP",
    lines: ["Lignes 7 · 20 · 39", "Arrêt Haussmann — Opéra"],
  },
  {
    icon: "🛎",
    title: "Voiturier",
    lines: ["Service 7j/7", "8h — 22h · 1 500 FCFA"],
  },
];

export function LocationSection() {
  return (
    <section id="location" className="relative bg-ink text-cream py-24 md:py-32 overflow-hidden">
      <div className="absolute inset-0 ink-gradient"></div>
      <div
        className="absolute inset-0 opacity-[0.05]"
        style={{
          backgroundImage:
            "linear-gradient(rgba(200,162,74,0.6) 1px, transparent 1px), linear-gradient(90deg, rgba(200,162,74,0.6) 1px, transparent 1px)",
          backgroundSize: "60px 60px",
        }}
      ></div>

      <div className="relative mx-auto max-w-7xl px-6">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-14">
          <div className="ornament-line mb-6 justify-center">
            <span className="text-gold text-[11px] tracking-[0.35em] uppercase">
              Nous trouver
            </span>
          </div>
          <h2 className="font-display text-cream text-4xl md:text-6xl leading-[1.05]">
            Une adresse,
            <br />
            <span className="gold-text italic">au cœur de Paris.</span>
          </h2>
        </div>

        <div className="grid lg:grid-cols-2 gap-8 md:gap-12">
          {/* Left: infos */}
          <div className="space-y-6">
            {/* Address */}
            <div className="bg-cream/5 backdrop-blur-sm border border-cream/15 rounded-xl p-6">
              <div className="flex items-center gap-3 mb-3">
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="text-gold"
                >
                  <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"></path>
                  <circle cx="12" cy="10" r="3"></circle>
                </svg>
                <span className="text-gold text-[11px] tracking-[0.3em] uppercase">
                  Adresse
                </span>
              </div>
              <div className="font-display text-cream text-xl leading-snug">
                12 Boulevard Haussmann, Paris 9e
              </div>
              <div className="text-cream/55 text-sm mt-1">France</div>
              <a
                href="https://maps.google.com/?q=12+Boulevard+Haussmann+Paris"
                target="_blank"
                rel="noreferrer"
                className="mt-4 inline-flex items-center gap-2 text-gold hover:text-gold-dark text-[11px] tracking-[0.25em] uppercase border-b border-gold/40 pb-0.5 transition-colors"
              >
                Ouvrir dans Google Maps
                <svg
                  width="11"
                  height="11"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M7 7h10v10"></path>
                  <path d="M7 17 17 7"></path>
                </svg>
              </a>
            </div>

            {/* Hours */}
            <div className="bg-cream/5 backdrop-blur-sm border border-cream/15 rounded-xl p-6">
              <div className="flex items-center gap-3 mb-4">
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="text-gold"
                >
                  <circle cx="12" cy="12" r="10"></circle>
                  <path d="M12 6v6l4 2"></path>
                </svg>
                <span className="text-gold text-[11px] tracking-[0.3em] uppercase">
                  Horaires d&apos;ouverture
                </span>
              </div>
              <ul className="space-y-2.5">
                {HOURS.map((h, idx) => (
                  <li
                    key={idx}
                    className="flex items-center justify-between text-sm pb-2 border-b border-cream/8 last:border-b-0 last:pb-0"
                  >
                    <span className="text-cream/70">{h.day}</span>
                    <span className="font-display text-cream">{h.hours}</span>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact + Parking grid */}
            <div className="grid sm:grid-cols-2 gap-4">
              <div className="bg-cream/5 backdrop-blur-sm border border-cream/15 rounded-xl p-6">
                <div className="flex items-center gap-3 mb-3">
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="text-gold"
                  >
                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92Z"></path>
                  </svg>
                  <span className="text-gold text-[10px] tracking-[0.3em] uppercase">
                    Téléphone
                  </span>
                </div>
                <a
                  href="tel:+33142311000"
                  className="font-display text-cream text-lg hover:text-gold transition-colors"
                >
                  +33 1 42 31 10 00
                </a>
              </div>
              <div className="bg-cream/5 backdrop-blur-sm border border-cream/15 rounded-xl p-6">
                <div className="flex items-center gap-3 mb-3">
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="text-gold"
                  >
                    <rect width="18" height="18" x="3" y="3" rx="2"></rect>
                    <path d="M7 7h10v10H7z"></path>
                  </svg>
                  <span className="text-gold text-[10px] tracking-[0.3em] uppercase">
                    Parking
                  </span>
                </div>
                <div className="font-display text-cream text-lg">
                  380 places
                </div>
                <div className="text-cream/55 text-sm mt-0.5">Gratuit</div>
              </div>
            </div>
          </div>

          {/* Right: stylized map */}
          <div className="relative">
            <div className="relative bg-cream/5 backdrop-blur-sm border border-cream/15 rounded-2xl p-8 md:p-10 min-h-[400px] overflow-hidden">
              {/* Map grid background */}
              <div
                className="absolute inset-0 opacity-30"
                style={{
                  backgroundImage:
                    "linear-gradient(rgba(200,162,74,0.4) 1px, transparent 1px), linear-gradient(90deg, rgba(200,162,74,0.4) 1px, transparent 1px)",
                  backgroundSize: "40px 40px",
                }}
              ></div>
              {/* River (Seine) */}
              <div className="absolute left-0 right-0 top-[55%] h-12 bg-gradient-to-r from-gold/10 via-gold/30 to-gold/10 rounded-full opacity-50"></div>
              <span className="absolute right-6 top-[58%] text-cream/40 text-[10px] tracking-[0.25em] uppercase">
                Seine
              </span>
              {/* Boulevard Haussmann line */}
              <div className="absolute left-0 right-0 top-[35%] h-px bg-gold/40"></div>
              <span className="absolute left-6 top-[32%] text-cream/50 text-[10px] tracking-[0.2em] uppercase">
                Haussmann
              </span>
              {/* Opéra */}
              <div className="absolute left-[15%] top-[28%]">
                <div className="w-2 h-2 rounded-full bg-cream/60"></div>
                <span className="absolute top-3 left-3 text-cream/50 text-[10px] tracking-[0.2em] uppercase">
                  Opéra
                </span>
              </div>
              {/* Hyper OR pin */}
              <div className="absolute left-[55%] top-[36%] -translate-x-1/2 -translate-y-1/2">
                <div className="relative">
                  <div className="w-12 h-12 rounded-full bg-gold/20 animate-pulse"></div>
                  <div className="absolute inset-0 m-auto w-6 h-6 rounded-full bg-gold flex items-center justify-center">
                    <span className="font-display italic text-ink text-xs leading-none">
                      OR
                    </span>
                  </div>
                </div>
                <div className="absolute top-14 left-1/2 -translate-x-1/2 text-center whitespace-nowrap">
                  <div className="font-display text-gold text-base">
                    Hyper OR I
                  </div>
                  <div className="text-cream/50 text-[10px] tracking-[0.2em] uppercase">
                    Haussmann · Paris
                  </div>
                </div>
              </div>
              {/* Compass */}
              <div className="absolute top-6 right-6 flex items-center gap-2 text-cream/40">
                <span className="font-display text-gold text-xl">N</span>
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.5"
                >
                  <path d="m12 2 4 12-4-2-4 2Z" fill="currentColor"></path>
                </svg>
              </div>
              {/* Scale */}
              <div className="absolute bottom-6 right-6 flex items-center gap-2">
                <div className="h-px w-12 bg-cream/40"></div>
                <span className="text-cream/40 text-[10px] tracking-[0.2em] uppercase">
                  500 m
                </span>
              </div>
              {/* Arrondissement label */}
              <div className="absolute bottom-6 left-6">
                <div className="text-cream/40 text-[10px] tracking-[0.25em] uppercase">
                  9ᵉ arrondissement
                </div>
              </div>
            </div>

            {/* Access cards below */}
            <div className="grid sm:grid-cols-3 gap-3 mt-4">
              {ACCESS.map((a, idx) => (
                <div
                  key={idx}
                  className="bg-cream/5 border border-cream/15 rounded-xl p-4"
                >
                  <div className="text-xl mb-2">{a.icon}</div>
                  <div className="text-gold text-[10px] tracking-[0.25em] uppercase mb-1">
                    {a.title}
                  </div>
                  {a.lines.map((line, j) => (
                    <div key={j} className="text-cream/60 text-xs">
                      {line}
                    </div>
                  ))}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
